import { I18n } from '@calendly/i18n';
import { IconTrash } from '@calendly/ui/components/glyphs/IconTrash';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseMiniIcon } from '@calendly/ui/components/icons';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const disabledWeekdayIsPhoneCss = "div1do2";
const disabledWeekdayIsV4Css = "d19wlyum";
const disabledWeekdayCss = "d161gfgk";
export const DisabledWeekday = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    v4Styling = false,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(disabledWeekdayCss, {
    [disabledWeekdayIsPhoneCss]: isPhone && !v4Styling,
    [disabledWeekdayIsV4Css]: v4Styling
  }, props.className)}>
      {I18n.t('publisher.event_types.availability.unavailable')}
    </Component>;
});
const containerIsTabletUpCss = "cmb9apf";
const containerIsPhoneCss = "c1vmsozv";
const containerIsV4Css = "c19lasw0";
const containerCss = "c4xd76s";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    v4Styling = false,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsTabletUpCss]: isTabletUp && !v4Styling,
    [containerIsPhoneCss]: isPhone && !v4Styling,
    [containerIsV4Css]: v4Styling
  }, props.className)} />;
});
const removeIntervalButtonCss = "rxy4qse";
const removeIntervalButtonIsV4Css = "r1fi0k2w";
export const RemoveIntervalButton = forwardRef((props, ref) => {
  const {
    v4Styling,
    ...restProps
  } = props;
  return <IconButton ref={ref} {...restProps} size={v4Styling ? 'small' : restProps.size} className={classNames(removeIntervalButtonCss, {
    [removeIntervalButtonIsV4Css]: v4Styling
  }, props.className)}>
      {v4Styling ? <UiIcon icon={IconTrash} size="small" /> : <CloseMiniIcon />}
    </IconButton>;
});
const dashCss = "d10xy17n";
export const Dash = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dashCss, props.className)}>
      -
    </Component>;
});
const timeInputsContainerCss = "t64eabx";
export const TimeInputsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timeInputsContainerCss, props.className)} />;
});
const inputCss = "i1ibq8oh";
export const Input = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  return <Component ref={ref} {...restProps} className={classNames(inputCss, props.className)} />;
});

// Export CSS classes for external usage
export { containerCss, dashCss, disabledWeekdayCss, inputCss, removeIntervalButtonCss, timeInputsContainerCss };

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");